"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactStripeJs = require("@stripe/react-stripe-js");

var _stripeJs = require("@stripe/stripe-js");

var _StripeWrapper = _interopRequireDefault(require("./CardPaymentComponents/StripeWrapper"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var CardPayment = function CardPayment(_ref) {
  var publishableKey = _ref.publishableKey,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      apiQuery = _ref.apiQuery,
      onPaymentActionSuccess = _ref.onPaymentActionSuccess,
      onPaymentActionFail = _ref.onPaymentActionFail,
      children = _ref.children;

  var _useState = (0, _react.useState)(null),
      stripePromise = _useState[0],
      setStripePromise = _useState[1];

  (0, _react.useEffect)(function () {
    (0, _stripeJs.loadStripe)(publishableKey).then(function (res) {
      return setStripePromise(res);
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_reactStripeJs.Elements, {
    stripe: stripePromise
  }, /*#__PURE__*/_react["default"].createElement(_StripeWrapper["default"], {
    stripe: stripePromise,
    onSubmit: onSubmit,
    onCancel: onCancel,
    apiQuery: apiQuery,
    onPaymentActionSuccess: onPaymentActionSuccess,
    onPaymentActionFail: onPaymentActionFail
  }), children);
};

var _default = CardPayment;
exports["default"] = _default;